/**
 * Which fleets are simulated (twin slice 1, contract C0; plan W3 step 9).
 *
 * The same predicate the twin screen applies today (`TwinScreen.tsx`,
 * `SIMULATED_FLEET_PREFIX`): a fleet whose name starts with `mock`, in
 * any case. At sg-nomad-01 that is `mock_phantas` (robot `mock_01`). It
 * is a real RMF participant -- auctions, paths and lifts genuinely run
 * through the stack -- so it is drawn, but it must never be mistaken for
 * the real robot in front of a client.
 *
 * NOT a general test for "simulated". hotel2's simulated `cleanerBotA`
 * does not match it; slice 1 is NoMad only, and a predicate for other
 * sites is not established. Nothing in the 2D map identifies a simulated
 * fleet today.
 */
export const SIMULATED_FLEET_PREFIX = 'mock';

export function isSimulatedFleet(fleetName: string | null | undefined): boolean {
  return (
    typeof fleetName === 'string' && fleetName.toLowerCase().startsWith(SIMULATED_FLEET_PREFIX)
  );
}
